import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import store from "./store.ts";
import { App } from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { ThemeProvider } from "./contexts/ThemeContext.tsx";
import { LanguageProvider } from "./contexts/LanguageContext.tsx";
import { applyBrandTheme } from "./config/branding";
import { initConsentGatedServices } from "./utils/consent";
import "./i18n"; // Initialize i18n
import "./index.css";
import { captureFirstTouchAttribution } from './lib/attribution';

captureFirstTouchAttribution();

// Initialize analytics only if user previously consented
// PostHog is deferred until consent is granted (GDPR/CCPA compliance)
initConsentGatedServices();

applyBrandTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <HelmetProvider>
          <Provider store={store}>
            <BrowserRouter>
              <LanguageProvider>
                <App />
              </LanguageProvider>
            </BrowserRouter>
          </Provider>
        </HelmetProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>
);
// Cache bust 1775731675
